export const environment = {
  production: false,
  apiUrl: "https://environer-dev.une.edu.au/web-api",
  webUrl: "https://environer-dev.une.edu.au/#!/out/"
};
